import { type AsyncStateObject, type Action, type GoalCreatAndUpdateResponse } from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, GOAL_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<GoalCreatAndUpdateResponse> = {
  data: { message: '' },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined

}

const updateGoalReducer = (state = INITIAL_STATE, action: Action<GoalCreatAndUpdateResponse>) => {
  switch (action.type) {
    case GOAL_ACTIONS.UPDATE_GOAL + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case GOAL_ACTIONS.UPDATE_GOAL + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case GOAL_ACTIONS.UPDATE_GOAL + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case GOAL_ACTIONS.UPDATE_GOAL + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default updateGoalReducer
